import React from 'react';

export default function AboutVisual() {
  return (
    <div className="about-visual" aria-hidden="true">
      <svg
        className="about-visual-svg"
        viewBox="0 0 520 420"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <linearGradient id="aboutFade" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#050505" stopOpacity="0" />
            <stop offset="100%" stopColor="#050505" stopOpacity="0.85" />
          </linearGradient>
          <radialGradient id="aboutGlow" cx="50%" cy="45%" r="55%">
            <stop offset="0%" stopColor="#2fffb8" stopOpacity="0.22" />
            <stop offset="100%" stopColor="#00d076" stopOpacity="0" />
          </radialGradient>
        </defs>

        <rect width="520" height="420" fill="url(#aboutGlow)" />

        <g opacity="0.35">
          <rect x="40" y="260" width="48" height="110" rx="3" fill="#1a2420" />
          <rect x="100" y="230" width="62" height="140" rx="3" fill="#141c18" />
          <rect x="380" y="245" width="70" height="125" rx="3" fill="#141c18" />
          <rect x="460" y="270" width="44" height="100" rx="3" fill="#1a2420" />
        </g>

        <circle cx="260" cy="155" r="52" fill="none" stroke="#00d076" strokeWidth="1.2" opacity="0.4" />
        <ellipse cx="260" cy="155" rx="52" ry="16" fill="none" stroke="#2fffb8" strokeWidth="0.8" opacity="0.25" />

        <g opacity="0.9">
          <g transform="translate(155 285)">
            <circle cx="0" cy="-52" r="20" fill="#c68642" />
            <path d="M-30 68 Q0 26 30 68 L30 100 L-30 100 Z" fill="#1f2933" />
          </g>
          <g transform="translate(260 275)">
            <circle cx="0" cy="-56" r="21" fill="#8d5524" />
            <path d="M-32 72 Q0 28 32 72 L32 108 L-32 108 Z" fill="#243028" />
            <rect x="-16" y="14" width="32" height="44" rx="6" fill="#00d076" opacity="0.75" />
          </g>
          <g transform="translate(365 285)">
            <circle cx="0" cy="-52" r="20" fill="#f1c27d" />
            <path d="M-30 68 Q0 26 30 68 L30 100 L-30 100 Z" fill="#1a2330" />
          </g>
        </g>

        <path
          d="M155 240 L220 190 L260 155 L300 190 L365 240"
          fill="none"
          stroke="#00d076"
          strokeWidth="1"
          opacity="0.35"
        />

        <rect width="520" height="420" fill="url(#aboutFade)" />
      </svg>
    </div>
  );
}
